import React from 'react';
import classNames from 'classnames';

const ClassificationsTable = ({
    rows = [],
    columns = [],
    footer = null,
    className = '',
    emptyState = null,
    afterTable = null,
    scrollable = false
}) => {
    if (!rows || rows.length === 0) {
        return emptyState || null;
    }

    const tableClassName = classNames(
        className || 'table table--striped table--num',
        {
            'table--border-bottom': !footer,
            'table--border-top': !!footer
        },
    );

    const tableElement = (
        <table className={tableClassName}>
            <thead>
                <tr>
                    {columns.map(column => (
                        <th
                            key={column.key}
                            className={classNames({
                                'table__text': column.isTextHeader,
                                ...(column.headerClassNames || {})
                            })}
                        >
                            {column.label}
                            {column.sublabel && (
                                <span className="table__light-header"> ({column.sublabel})</span>
                            )}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.map(row => (
                    <tr key={row.key || row.id || row.name}>
                        {columns.map(column => (
                            <td
                                key={`${row.key || row.id || row.name}-${column.key}`}
                                className={classNames({
                                    'table__text': column.isTextCell,
                                    ...(column.cellClassNames || {})
                                })}
                            >
                                {column.render(row)}
                            </td>
                        ))}
                    </tr>
                ))}
                {footer && (
                    <tr className="tfoot">
                        {footer.map((footerCell, index) => (
                            <td
                                key={`footer-${index}`}
                                className={classNames({
                                    'table__text': footerCell.isText,
                                    ...(footerCell.classNames || {})
                                })}
                            >
                                {footerCell.content}
                            </td>
                        ))}
                    </tr>
                )}
            </tbody>
        </table>
    );

    const content = scrollable ? (
        <div className="districts__table-scroll-fade">
            <div className="districts__table-scroll">{tableElement}</div>
        </div>
    ) : (
        <div className="districts__table-wrapper">{tableElement}</div>
    );

    return afterTable ? (
        <>
            {content}
            {afterTable}
        </>
    ) : content;
};

export default ClassificationsTable;

